export const dashboardUrl = process.env.NEXT_PUBLIC_DASHBOARD_URL;
export const recaptchaKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
export const supportFormUrl = process.env.NEXT_PUBLIC_SUPPORT_FORM_URL;
export const publicRegion = process.env.NEXT_PUBLIC_REGION;
